import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { streamingLines } from "@/mocks/movieData";

export default function LinesSection() {
  const [activeId, setActiveId] = useState(streamingLines[0].id);
  const active = streamingLines.find((line) => line.id === activeId) ?? streamingLines[0];

  return (
    <section id="lines" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Playback"
          title="播放线路说明：内容一致，体验不同"
          desc="三条线路的正片内容完全相同，区别在于传输节点与优化方向。若某条线路加载缓慢，切换到其它线路通常可以改善。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-4">
            <div role="tablist" aria-label="播放线路" className="flex flex-row lg:flex-col gap-2">
              {streamingLines.map((line) => {
                const isActive = line.id === activeId;
                return (
                  <button
                    key={line.id}
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => setActiveId(line.id)}
                    className={`flex-1 lg:flex-none text-left px-4 py-3 rounded-lg border cursor-pointer transition-colors ${
                      isActive
                        ? "bg-primary-500 border-primary-500 text-background-50"
                        : "bg-background-100 border-background-200 text-foreground-800 hover:border-primary-300 hover:bg-primary-50/50"
                    }`}
                  >
                    <span className="flex items-center justify-between gap-2">
                      <span className="text-sm font-medium whitespace-nowrap">{line.name}</span>
                      <i className={`ri-arrow-right-line ${isActive ? "text-accent-300" : "text-foreground-400"}`} />
                    </span>
                    <span
                      className={`mt-1 block text-xs ${isActive ? "text-background-200" : "text-foreground-500"}`}
                    >
                      状态：{line.status}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-xl border border-background-200 bg-background-100 overflow-hidden h-full">
              <div className="relative w-full aspect-[16/9] bg-foreground-950">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20dark%20cinematic%20frame%20with%20soft%20amber%20light%20streaks%20and%20deep%20shadow%20gradient%2C%20subtle%20film%20grain%20texture%2C%20minimal%20moody%20atmosphere%2C%20warm%20gold%20highlights%20on%20black%2C%20elegant%20and%20understated&width=1280&height=720&seq=play-screen-01&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover object-top opacity-70"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 text-3xl">
                    <i className="ri-play-fill" />
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs backdrop-blur">
                  {active.name}
                </span>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-foreground-950/70 text-accent-300 text-xs backdrop-blur">
                  无删减完整版
                </span>
              </div>

              <div className="p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-label">
                    {active.tag}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label">
                    {active.status}
                  </span>
                </div>
                <p className="mt-4 text-sm md:text-base text-foreground-800 leading-relaxed">{active.feature}</p>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">适合场景：{active.suited}</p>

                <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {active.points.map((point) => (
                    <li
                      key={point}
                      className="flex items-start gap-2 text-sm text-foreground-700 bg-background-50 border border-background-200 rounded-md px-3 py-2.5"
                    >
                      <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 shrink-0" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}